export class CommonResponse {
  Code: number;
  Message: string;

  constructor(code: number = 0, message: string = '') {
    this.Code = code;
    this.Message = message;
  }
}

export class LoginMail {
  Id: number;
  Mail: string;
  PassWord: string;

  constructor() {
    this.Id = 0;
    this.PassWord = "";
    this.Mail = "";
  }
}

export class LoginAsker {
  Mail: string;
  Password: string;
  ServerLink: string;
  Language: number;

  SessionType: number;//тип подключения - веб = 0, андроид = 1, иос =2
  DeviceId: string;//ИД устройства для андроид/иос
  PushNotificationToken: string;//токен для пушей  для андроид/иос

  constructor() {
    this.Mail = "";
    this.Password = "";
    this.ServerLink= "";
    this.Language = 0;

    this.SessionType= 0;//тип подключения - веб = 0, андроид = 1, иос =2
    this.DeviceId = "";//ИД устройства для андроид/иос
    this.PushNotificationToken = "";//токен для пушей  для андроид/иос
  }
}

// export class LoginGiver extends CommonResponse {
//   UserId: number;
//   SessionKey: string;
//   UserAuthToken: string;
// }

export class LoginGiver extends CommonResponse {
  UserId: number;
  SessionKey: string;
  UserAuthToken: string;

  constructor() {
    super();
    this.UserId = 0;
    this.SessionKey = "";
    this.UserAuthToken= "";
  }
}

export class RecoverAsker {
  Value: string;
  Language: number;

  constructor() {
    this.Value = "";
    this.Language = 1;
    // this.UserAuthToken= "";
  }
}

export class RecoverWaitGiver extends CommonResponse {
  SecondsToWait: number;

  constructor() {
    super();
    this.SecondsToWait = 1;
  }
}

export class Login_LangSet {
  ChangeTime: Date = new Date(); //время последнего редактирования сета

  Email: string = "Email"; //Email
  IncorrectEmail: string = "Некорректный e-mail"; //Некорректный e-mail
  Password: string = "Пароль"; //Пароль
  Login: string = "Войти"; //Войти
  EnterMessage: string = "Вход в систему"; //Вход в систему
  ForgotPassword: string = ""; //Забыли пароль?
  Unsigned: string = ""; // Не зарегестрированны?
  UnsignedHintMessage: string = "Для регистрации в системе обратитесь к администратору"; //Для регистрации в системе обратитесь к администратору
  CompanyNervousSystem: string = ""; //Нервная система вашей компании
  EmptyEmail: string = ""; //Email не указан
  PasswordEmpty: string = ""; //Пароль не указан
  MailPasswordInvalid: string = ""; //Неверно указан email или пароль
  PasswordRecovering: string = "Восстановление пароля"; //Восстановление пароля
  PasswordRecoveringButton: string = "Восстановить пароль"; //Восстановить пароль
  AuthorizationProblem: string = "Проблемы с авторизацией?"; //Проблемы с авторизацией?
  InputUsedEmail: string = "Пожалуйста, введите e-mail, который вы использовали для входа в систему"; //Пожалуйста, введите e-mail, который вы использовали для входа в систему
  Next: string = ""; //Далее
  Back: string = "Вернуться назад"; //Вернуться назад
  RestoringAccessToAccount: string = "Восстановление доступа"; //Восстановление доступа

  LoginProblemNotificationDescription: string = "Уведомление о проблемах с авторизацией отправлено"; //Уведомление о проблемах с авторизацией отправлено
  DescribeProblem: string = "Опишите проблему";
  GetPasswordReminder: string = ""; //Получить напоминание о пароле
  LoginProblemNotificationSentToAdmins: string = ""; //Уведомление о проблемах с авторизацией было отправлено.
  SendResponce: string = "Отправить"; //Повторить запрос
  SendAgain: string = "Повторить запрос"; //Повторить запрос
  PasswordSentToMail: string = "На указанную почту отправлен новый пароль для восстановления доступа к системе"; //На указанную почту отправлен новый пароль для восстановления доступа к системе
  RepeatResponsePasswordMessage: string = "На указанную почту отправлен новый пароль для восстановления доступа к системеЕсли вы не получили пароль в течение 15 минут, отправьте запрос повторно. Рекомендуется немедленно сменить пароль"; //Если вы не получили пароль в течение 15 минут, отправьте запрос повторно. Рекомендуется немедленно сменить пароль
  WriteContactDataMessage: string = "Укажите контактные данные для связи, должность, отдел и описание проблемы"; // Укажите контактные данные для связи, должность, отдел и описание проблемы
  SendContactDataMessage: string = "Сообщение о проблеме с авторизацией будет отправлено адмистраторам, и они помогут восстановить доступ к системе"; //Сообщение о проблеме с авторизацией будет отправлено адмистраторам, и они помогут восстановить доступ к системе
  EmailInvalid: string = ""; //Почтовый адрес указан неверно
  EmailEmpty: string = ""; //Почтовый адрес не указан
  NoWorkerWithEmailFound: string = ""; //Пользователь с указанной почтой не найден
}